import React from 'react'

import { formatName } from '@paintscout/util/builder'
import type { TaskActivityDetails } from '@paintscout/api'
import Highlight from '@paintscout/ui/components/Highlight'
import type { ActivityTypeComponentProps } from '../Activity'
import ActivityFooter from '../ActivityFooter'
import ActivityTitle from '../ActivityTitle'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'
import { useUsers } from '../../../providers/UsersProvider'
import { withLiveOwnerName } from '../../../util/withLiveOwnerName'

export default function TaskActivity(props: ActivityTypeComponentProps) {
  const { activity, showDocTypeDetails } = props
  const { usersById } = useUsers()
  const activityType = activity.details?.activityType
  const action = (activityType || '').replace('task-', '')

  // The owner snapshot is frozen at write time, so a renamed seat keeps rendering the previous
  // person's name. Resolve the live name the same way ActivityAvatar does (#21800).
  const ownerToDisplay = withLiveOwnerName(
    activityType === 'task-assigned' ? activity.details.quoteOwner : activity.details.owner,
    usersById
  )

  const isTemplateAdded = activityType === 'task-created' && !!(activity.details as TaskActivityDetails)?.templateId

  return (
    <>
      <ActivityTitle>
        {isTemplateAdded ? (
          <>
            <Highlight>Checklist</Highlight> was <Highlight>added</Highlight> by
          </>
        ) : (
          <>
            <Highlight>Task</Highlight> was <Highlight>{action}</Highlight>{' '}
            {activityType === 'task-assigned' ? 'to' : 'by'}
          </>
        )}

        {'  '}
        <Highlight>{formatName(ownerToDisplay)}</Highlight>
      </ActivityTitle>
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
